import { useEffect, useState } from "react";
import { FormDataConsumer, Create, SimpleForm, useDataProvider, useStore } from "react-admin";
import { Grid, Typography } from "@mui/material";

import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";

import PersonalInfo from "./Partials/PersonalInfo";
import CandidacyInfo from "./Partials/CandidacyInfo";
import BackButtonToolbar from "features/BackButtonToolbar";
import { candidateRequests } from "api/candidateApi";
import { CampaignSubTypes, CitizenshipIds } from "utils/constants";
import { administrationRequests } from "api/administrationApi";
import { useNotifyError } from "utils/useNotifyError";
import dataProvider from "server/dataProvider";

const CreateBulgarianCandidacy = ({ title }) => {
  const notifyError = useNotifyError();
  const [selectedSpecialityIds, setSelectedSpecialityIds] = useState([]);
  const [availableExams, setAvailable] = useState(null);
  const [schoolSubjectsGrades, setSchoolSubjectGrades] = useState([]);
  // const [citizenshipId, setCitizenShip] = useState(null);
  const [laureatesData, setLaureate] = useState(null);
  const [laureateChoiceIds, setLaureateChoiceIds] = useState([]);
  const [filesLaureate, setFilesLaureate] = useState([]);
  const [components, setComponents] = useState([]);

  const [discount, setDiscount] = useState({});
  const [isFreeExams, setIsFreeExams] = useState(false);
  const [isFreeDocument, setIsFreeDocument] = useState(false);

  useEffect(() => {
    const discountList = Object.values(discount);

    const hasExamDiscount = discountList.some(item => item.discounts?.CandidateExams);
    const hasDocumentDiscount = discountList.some(item => item.discounts?.CandidateDocumentProcessing);

    setIsFreeExams(hasExamDiscount);
    setIsFreeDocument(hasDocumentDiscount);
  }, [discount]);

  // Read-only consumer of the committed campaign from the regular candidates list.
  const [filters] = useStore(`campaign-query-subtype-${CampaignSubTypes.Regular}`, null);
  const campaignId = filters?.campaignId ?? null;

  const transform = data => {
    if (data) {
      data.info.citizenshipId = 1;
      data.info.residenceCountryId = 21;
    }

    const scoreLineComponents = components.map(item => ({ lineId: item.lineId, componentId: item.componentId }));
    return {
      ...data,
      campaignId: Number(campaignId),
      schoolSubjectsGrades: schoolSubjectsGrades,
      laureateIds: laureateChoiceIds,
      components: scoreLineComponents,
      info: {
        ...data.info,
        secondName: data.info.secondName || "",
      },
    };
  };

  const handleSelectedSpecialityIds = data => {
    setSelectedSpecialityIds(data.map(p => p.specialityId));
  };
  useEffect(() => {
    if (selectedSpecialityIds?.length > 0) {
      const query = selectedSpecialityIds
        .filter(id => id != null)
        .map(id => `SpecialityIds=${id}`)
        .join("&");

      const fetchGrades = async () => {
        try {
          const { data } = await dataProvider.customRequest(
            candidateRequests.getSchoolSubjectsSpecialitiesSelect(),
            null,
            "GET",
            `?${query}&CitizenshipId=${CitizenshipIds.Bulgarians}`,
          );
          setAvailable(data);
        } catch (error) {
          notifyError(error);
        }
      };

      fetchGrades();
    } else {
      setAvailable([]);
    }
  }, [selectedSpecialityIds, notifyError]);

  useEffect(() => {
    const fetchLaureates = async () => {
      try {
        const { data } = await dataProvider.customRequest(administrationRequests.getLaureatesSelect(), null, "GET");
        setLaureate(data);
      } catch (error) {
        console.error("Error fetching laureates", error);
      }
    };
    fetchLaureates();
  }, []);

  return (
    <SecuredComponent permission={permissions.canCreateCandidacy}>
      <Create
        title={`Създаване на кандидатура на българин за кампания - ${title}`}
        // mutationOptions={{ meta: { useFormData: true } }}
        transform={transform}
        actions={<BackButtonToolbar />}
      >
        <SimpleForm>
          <FormDataConsumer>
            {({ formData, ...rest }) => (
              <>
                <Grid
                  item
                  xs={12}
                  md={12}
                  sx={{ margin: "0 auto 2rem " }}
                >
                  <Typography color={"primary"}>Данни за кандидата</Typography>
                </Grid>
                <PersonalInfo
                  discount={discount}
                  setDiscount={setDiscount}
                  formData={formData}
                  laureatesData={laureatesData}
                  laureateChoiceIds={laureateChoiceIds}
                  setLaureateChoiceIds={setLaureateChoiceIds}
                  filesLaureate={filesLaureate}
                  setFilesLaureate={setFilesLaureate}
                  isForeigner={false}
                />
                <Grid
                  item
                  xs={12}
                  md={12}
                  sx={{ margin: "0 auto 2rem" }}
                >
                  <Typography color={"primary"}>Данни за кандидатурата</Typography>
                </Grid>
                <CandidacyInfo
                  isFreeExams={isFreeExams}
                  isFreeDocument={isFreeDocument}
                  formData={formData}
                  components={components}
                  setComponents={setComponents}
                  laureateChoiceIds={laureateChoiceIds}
                  isForeigner={false}
                  selectedSpecialityIds={selectedSpecialityIds}
                  setSelectedSpecialityIds={setSelectedSpecialityIds}
                  handleSelectedSpecialityIds={handleSelectedSpecialityIds}
                  campaignId={campaignId}
                  availableExams={availableExams}
                  setSchoolSubjectGrades={setSchoolSubjectGrades}
                />
              </>
            )}
          </FormDataConsumer>
        </SimpleForm>
      </Create>
    </SecuredComponent>
  );
};
export default CreateBulgarianCandidacy;
